import React from "react";
import { AlertTriangle, RefreshCw } from "lucide-react";

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    console.error("UI crashed:", error, info);
  }

  render() {
    if (this.state.hasError) {
      return (
        <main className="grid min-h-screen place-items-center bg-white p-6">
          <section className="w-full max-w-md rounded-2xl border border-slate-200 bg-white p-7 text-center shadow-sm">
            <span className="mx-auto grid h-12 w-12 place-items-center rounded-2xl bg-amber-50 text-amber-600">
              <AlertTriangle size={23} />
            </span>
            <h1 className="mt-4 text-xl font-semibold text-slate-950">
              This screen could not load
            </h1>
            <p className="mt-2 text-sm text-slate-500">
              Refresh the page and try again.
            </p>
            <button
              type="button"
              onClick={() => window.location.reload()}
              className="mt-5 inline-flex h-11 items-center justify-center gap-2 rounded-xl crm-primary px-4 text-sm font-semibold text-white"
            >
              <RefreshCw size={17} />
              Refresh
            </button>
          </section>
        </main>
      );
    }

    return this.props.children;
  }
}
